<template>
  <div>
    <v-alert v-if="dataField.title" dense type="warning"> {{ dataField.title }}</v-alert >
    <v-simple-table     
    fixed-header
    height="500px"
    class="mt-2"
    >
      <template v-slot:default>
        <thead >
          <tr>
            <th class="text-right "><b>نام </b></th>
            <th class="text-right "><b>مقدار </b></th>
          </tr>
        </thead>
        <tbody>
          <tr 
          v-for="(item, index) in titles" 
          :key="index"
           >
            <td>{{ item }}</td>
            <td v-if='types[index] == "FileInput"'>    <v-img
              style="border: 1px solid #ccc; border-radius: 3px"
              height="40"
              width="60"
              v-show="reviewField[index]"
              :src="reviewField[index]"
            ></v-img></td>
            <td v-else-if='types[index] == "SelectBox"'>    
              {{ reviewField[index] }}
            </td>
            <td v-else>{{ dataPost[index]?dataPost[index]:'وارد نشده' }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: "ReviewField",
  props: ["dataField"],
  computed: {
    dataPost: {
      get() {
        this.$store.commit("updateDataPost", this.$store.state.dataPost);
        return this.$store.state.dataPost;
      },
    },
    dataGet: {
      get() {
        return this.$store.state.dataGet;
      },
    },
    reviewField: {
      get() {
        return this.$store.state.reviewField;
      },
    },
  },
  data: () => ({
    titles : {},
    types : {},
  }),
  mounted(){
    let titles = {};
    let types = {};
    this.dataGet.pages.map((item)=>{
      item.elements.map((EItem)=>{
        if(EItem.type != "TextBox" && EItem.type != "ReviewField"){
          titles[EItem.name] = EItem.title;
          types[EItem.name] = EItem.type
        }
      })

    })
    this.titles = titles;
    this.types = types;
  }
};
</script>
